<!---->
<template>
  <div class="container">
    <iframe src="https://mp.weixin.qq.com/s/tzJGxyvROspW6P-oE-xNQw" width="100%" height="100%" frameborder="0"></iframe>
  </div>
</template>
<style scoped>
.container {
  display: flex;
  padding-top: 12rem;
  background: #f5f6fa;;
}
</style>
<script setup>
</script>